import React, { useState, useEffect, useRef } from 'react';
import './Carousel.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { formatAuthor } from '../../composants/utils/utils';

const Carousel = ({slides}) => {
  const progressCircle = useRef(null);
  const progressContent = useRef(null);
  const onAutoplayTimeLeft = (s, time, progress) => {
    progressCircle.current.style.setProperty('--progress', 1 - progress);
    progressContent.current.textContent = `${Math.ceil(time / 1000)}s`;
  };


  return (  
      <Swiper 
        modules={[Autoplay]} 
        loop={true}
        speed={1000}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        }}
        onAutoplayTimeLeft={slides.length > 1 ? onAutoplayTimeLeft : undefined}
        className="carousel" style={{ height: '100%', width: '100%' }}>
        {slides.map((slide, index) => (
          <SwiperSlide key={index} className='carousel-slide active'>
            <img src={slide.cover || slide.photo} alt={slide.title} style={{backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: 'cover', width: '100%', height: '100%'}}/>
{
              slide.image == null ? <div className="carousel-content">
              <h1 className="animate__animated animate__fadeInDown">{slide.title}</h1>
              <p className="animate__animated animate__fadeInUp">{slide.subtitle}</p>
            </div> 
            :
            <section class="min-h-screen flex items-center justify-center">
              <div style={
                {
                  background: 'rgba(255, 255, 255, 0.85)'
                }
            } class="flex rounded-2xl shadow-lg max-w-3xl p-5 items-center">
                <div class="md:block hidden w-1/2">
                  <div>
                    <h1 title={slide.title} className="animate__animated animate__fadeInDown">{formatAuthor(slide.title, 20)}</h1>
                    <p title={slide.subtitle} className="animate__animated animate__fadeInUp">{formatAuthor(slide.subtitle, 30)}</p>
                  </div>
                </div>

                <div class="md:block hidden w-1/2">
                <p></p>
                </div>
              </div>
            </section>
            }

        </SwiperSlide>
          ))}
          {slides.length > 1 && <div className="autoplay-progress" slot="container-end">
          <svg viewBox="0 0 48 48" ref={progressCircle}>
            <circle cx="24" cy="24" r="20"></circle>
          </svg>
          <span ref={progressContent}></span>
        </div>
      }
      </Swiper>
    
  );
};

export default Carousel; 